//
import $ from 'jquery';
import config from './../../../config';

export function get_users( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
            url: config.apiurl + 'resignation/',
            data: {
				method: 'GET_USER_RES',
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_USER_RES",
				resignation: response
			});
		});

	}
}

export function get_departments( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
            url: config.apiurl + 'resignation/',
            data: {
				method: 'GET_DEPARTMENTS_RES',
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_DEPARTMENTS_RES",
				resignation: response
			});
		});

	}
}

export function save_resignation( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
            url: config.apiurl + 'resignation/',
            data: {
				method: 'SAVE_RESIGNATION',
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "SAVE_RESIGNATION",
				resignation: response
			});
		});

	}
}

export function get_resignation( user, res_id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
            url: config.apiurl + 'resignation/',
            data: {
				method: 'GET_RESIGNATION',
				user: user,
				res_id: res_id
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_RESIGNATION",
				resignation: response
			});
		});

	}
}

export function delete_resignation( user_id, id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
            url: config.apiurl + 'resignation/',
            data: {
				method: 'DELETE_RESIGNATION',
				user_id: user_id,
				resignation_id: id
            }
		})
		.then(function (response) {
			dispatch({
				type: "DELETE_RESIGNATION",
				resignation: response
			});
		});

	}

}

export function update_resignation_relieving_date( resignation_id, dateString ){
	return dispatch => {

		$.ajax({
			method: 'GET',
            url: config.apiurl + 'resignation/',
            data: {
				method: 'UPDATE_RESIGNATION_RELIEVING_DATE',
				resignation_id: resignation_id, 
				dateString: dateString
            }
		})
		.then(function (response) {
			dispatch({
				type: "UPDATE_RESIGNATION_RELIEVING_DATE",
				resignation: response
			});
		});

	}

}

export function update_resignation_last_date( resignation_id, dateString ){
	return dispatch => {

		$.ajax({
			method: 'GET',
            url: config.apiurl + 'resignation/',
            data: {
				method: 'UPDATE_RESIGNATION_LAST_DATE',
				resignation_id: resignation_id, 
				dateString: dateString
            }
		})
		.then(function (response) {
			dispatch({
				type: "UPDATE_RESIGNATION_LAST_DATE",
				resignation: response
			});
		});

	}

}



export function update_reason_of_resignation( resignation_id, reason ){
	return dispatch => {

		$.ajax({
			method: 'GET',
            url: config.apiurl + 'resignation/',
            data: {
				method: 'UPDATE_RESIGNATION_REASON',
				resignation_id: resignation_id, 
				reason: reason
            }
		})
		.then(function (response) {
			dispatch({
				type: "UPDATE_RESIGNATION_REASON",
				resignation: response
			});
		});

	}

}

export function approve_resignation( user_id, resignation_id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
            url: config.apiurl + 'resignation/',
            data: {
				method: 'APPROVE_RESIGNATION',
				resignation_id: resignation_id,
				user_id: user_id,
            }
		})
		.then(function (response) {
			dispatch({
				type: "APPROVE_RESIGNATION",
				resignation: response
			});
		});

	}

}

export function reject_resignation( user_id, resignation_id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
            url: config.apiurl + 'resignation/',
            data: {
				method: 'REJECT_RESIGNATION',
				resignation_id: resignation_id,
				user_id: user_id,
            }
		})
		.then(function (response) {
			dispatch({
				type: "REJECT_RESIGNATION",
				resignation: response
			});
		});

	}

}


export function update_checklist_value( checklist_id, value ){
	return dispatch => {

		$.ajax({
			method: 'GET',
            url: config.apiurl + 'resignation/',
            data: {
				method: 'UPDATE_CHECK_VALUE',
				checklist_id: checklist_id,
				value: value
            }
		})
		.then(function (response) {
			dispatch({
				type: "UPDATE_CHECK_VALUE",
				resignation: response
			});
		});

	}

}





// WEBPACK FOOTER //
// ./src/pages/resignation/actions/resignation.action.js